<template>
  <div class="collectionPayment">
    <div class="title text-no">
      <div class="flex1">
        <div
          class="tabs"
          :class="tab == 1 ? 'tabBorder' : ''"
          @click="cutover(1)"
        >
          未退款
        </div>
        <div
          class="tabs"
          :class="tab == 2 ? 'tabBorder' : ''"
          @click="cutover(2)"
        >
          已退款
        </div>
      </div>
    </div>
    <div class="main">
      <NotARefund v-if="tab == 1"></NotARefund>
      <refunded v-if=" tab == 2"></refunded>
    </div>
  </div>
</template>

<script>
import NotARefund from './component/NotARefund.vue'
import refunded  from './component/refunded.vue'
import { paths } from '../../utils/pathNew.js'

export default {
  data() {
    return {
      tab: window.sessionStorage.getItem("collection") == null? (window.localStorage.getItem("collection") == null?1 : window.localStorage.getItem("collection")) : window.sessionStorage.getItem("collection") ,
    };
  },
  components:{
    refunded,
    NotARefund
  },
  methods: {
    cutover(i) {
      if (i == this.tab) return;
      this.tab = i;
      window.localStorage.setItem("collection", i);
      window.sessionStorage.setItem("collection", i);
    },
  },
  
  created(){
        // Tab 导航栏 样式跟随
    let url = window.location.hash;
    this.$store.commit("urlIndex", paths(url));
  }
};
</script>

<style lang='less'>
.collectionPayment {
  font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  flex: 1;
  display: flex;

  flex-direction: column;
  overflow: auto;
  background-color: #f7f7f8ff;

  .title {
    display: flex;
    height: 46px;
    line-height: 44px;
    box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    border: 1px solid #ececec;
    background-color: #fff;
    .flex1 {
      flex: 1;
      display: flex;
      justify-content: center;
      justify-content: center;
      cursor: pointer;
      .tabs {
        flex: 1;
        margin: 0 25px;
        max-width: 64px;
        &:hover {
          color: #008cffff;
          border-bottom: 2px solid #008cffff;
          max-width: 64px;
        }
      }
    }
  }
  .main {
    flex: 1;
    overflow: auto;
    margin: 16px 24px;
    // background-color: #fff;
    border-radius: 4px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
  }
}
.tabBorder {
 // color: #000;
  border-bottom: 2px solid #008cffff;
  max-width: 64px;
  color:#008cffff ;
}
</style>